<div class="public-account">
  <main class="public-account__main">
    <div class="public-account__card">
      <div class="public-account__language">
        <language-selector />
      </div>
      <header class="public-account__header">
        <div class="public-account__logo">
          <span class="public-account__logo-pill">
            <span class="public-account__logo-mark">Mechanics in Motion</span>
            <span class="public-account__logo-by">by Egitura</span>
          </span>
        </div>
        <h1 class="public-account__title">{{ heading() }}</h1>
        @if (subheading()) {
          <p class="public-account__subtitle">{{ subheading() }}</p>
        }
      </header>

      <div class="public-account__body">
        <ng-content />
      </div>
    </div>
  </main>
</div>
